
export const CHANGE_ACCOUNT = 'changeAccount';
export const CHANGE_MARKETPLACE = 'changeMarketplace';
export const CHANGE_ACCOUNT_MARKETPLACE = 'changeAccountMarketplace';

export function changeAccount(accountId) {
    return { type: CHANGE_ACCOUNT, accountId: accountId };
}

export function changeMarketplace(marketplace) {
    return { type: CHANGE_MARKETPLACE, marketplace: marketplace };
}

export function changeAccountMarketplace(accountId, marketplace, accounts) {
    return { type: CHANGE_ACCOUNT_MARKETPLACE, accountId: accountId, marketplace: marketplace, accounts: accounts };
}
